import React, { FC, useContext } from 'react';
import styled from 'styled-components';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import { TXN_TYPES } from '@constants/enrollmentList/enrollmentList.constant';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';
import Note from '../Note';
import AddOrChangeReasonField from './AddOrChangeReasonField';
import AddOrChangeTxnFooter from './AddOrChangeTxnFooter';
import EnrollmentTransactionTypeDropdown from './EnrolleeTransactionTypeDropdown';
import EnrollmentTxnTable from './EnrolleeTxnTable';
import EnrollmentAPTCAmounField from './EnrollmentAPTCAmounField';
import EnrollmentLastPremPaidThroughDate from './EnrollmentLastPremPaidDateField';
import EnrollmentStartDateField from './EnrollmentStartDateField';

const StyledContaner = styled.div`
    padding: 1rem;
`;

const StyledSection = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    width: 100%;
    align-items: center;

    .gi-input {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        margin: 0;
        gap: 0.5rem;
    }

    .gi-input__label {
        margin: 0;
        padding: 0;
        white-space: nowrap;
    }

    #aptcAmount {
        text-align: right;
        max-width: 80px;
    }
`;

const StyledGridItem = styled.div`
    min-width: 0;
    width: 100%;
`;

const AddOrChangeEnrollmentTxnForm: FC = () => {
    const { isEdit } = useContext(EnrollmentContext);
    const {
        watch,
        formState: { errors },
    } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    return (
        <StyledContaner>
            <ConditionalRendering isTrue={!isEdit}>
                <StyledSection>
                    <StyledGridItem>
                        <EnrollmentStartDateField />
                    </StyledGridItem>
                    <StyledGridItem>
                        <EnrollmentAPTCAmounField />
                    </StyledGridItem>
                </StyledSection>
            </ConditionalRendering>
            <ConditionalRendering isTrue={isEdit}>
                <EnrollmentTransactionTypeDropdown />
            </ConditionalRendering>
            <EnrollmentTxnTable />
            <ConditionalRendering isTrue={errors.enrolleeEndDateUnchanged}>
                <Note message="error.member.enrollment_list.termEnrollee.endDateError" />
            </ConditionalRendering>
            <ConditionalRendering isTrue={isEdit && values.enrollmentLevelTxnType === TXN_TYPES.Term}>
                <Note message="member.enrollment_list.premiumhistory.termTransaction.note" />
            </ConditionalRendering>
            <EnrollmentLastPremPaidThroughDate />
            <AddOrChangeReasonField />
            <ConditionalRendering isTrue={!isEdit}>
                <Note message="member.enrollment_list.premiumhistory.aptcAmount.note" />
            </ConditionalRendering>
            <AddOrChangeTxnFooter />
            <ConditionalRendering isTrue={values.isTermReasonNonPayment}>
                <Note message="member.enrollment_list.premiumhistory.send834.note" />
            </ConditionalRendering>
            <ConditionalRendering isTrue={values.isTermReasonNonPayment}>
                <Note
                    message="member.enrollment_list.premiumhistory.isTermReasonNonPayment.note"
                    isNoteLabelVisible={false}
                />
            </ConditionalRendering>
        </StyledContaner>
    );
};

export default AddOrChangeEnrollmentTxnForm;
